/**
 * Sets first letter to lowercase and returns that string;
 * @param str
 * @return {string}
 */
export function unCapitalize(str) {
	return str.split('').shift().toLowerCase() + str.slice(1);
}
